<template>
  <div>
    <div class="bg">
      <div class="main">
        <!-- <div class="companyInfo">
                    <el-row :gutter="84">
                        <el-col :span="8">
                            <div class="grid-content bg-purple">
                                <div>
                                    <img class="logo" src="../../assets/img/footerlogo.png" alt="">
                                </div>
                                <div class="infoText">
                                    由梧桐花教育平台推出，让每一个有提升愿望的用户能够学到 中国知 名高校的课程，并获得专业机构认证。
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="9">
                            <div class="grid-content bg-purple adr">
                                <img src="../../assets/img/location.png" alt="">
                                <div>
                                    <div class="addr">郑州市高新技术产业开发区冬青街26号河南电子商务产业园</div>
                                    <div class="phone">15638881604</div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="7">
                            <div class="grid-content bg-purple ">
                                <div class="qrCode">
                                    <img class="qrcImg" src="../../assets/img/qrcodeLogo.jpg"/>
                                    <span>扫一扫体验小程序</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div> -->
        <div class="Website">
          <!-- <div class="alist">
            <div @click="goAction(1)">青蓝云</div>
            <div @click="goAction(2)">青蓝云后台管理系统</div>
          </div> -->

          <div class="line"></div>
          <div class="mtop">
            Copyright ©2020 www.maisuiedu.com 梧桐花教育集团  版权所有
            <a class="cursorcolor" href="https://beian.miit.gov.cn">豫ICP备16014068号-4</a>
          </div>
          <div>技术支持：河南梧桐花科技有限公司</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
export default {
  data() {
    return {}
  },
  methods: {
    goAction(index) {
      switch (index) {
        case 1:
          window.open('http://product.maisuiedu.com/')
          break
        case 2:
          window.open('http://college.maisuiedu.com/')
          break

        default:
          break
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.cursorcolor{
  color: rgba(255, 255, 255, 0.3);
  text-decoration: none;
}
.bg {
  width: 100%;
  background: #1c2025;
  height: 130px;
  // position: fixed;
  // bottom: 0px;
}

.line {
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 10px 0px;
  height: 1px;
  background: #ffffff;
  opacity: 0.2;
}
.alist {
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    margin: 0px 10px;
    cursor: pointer;
  }
}
.mtop {
  margin-top: 20px;
}
.companyInfo {
  height: 200px;
  .logo {
    margin-top: 58px;
    width: 166px;
  }
  .infoText {
    margin-top: 16px;
    color: #999999;
    line-height: 18px;
  }
}
.adr {
  margin-top: 93px;
  display: flex;
  img {
    vertical-align: middle;
    width: 25px;
    height: 30px;
  }
  .addr {
    font-size: 12px;
    margin-top: 2px;
    color: rgba(153, 153, 153, 1);
    margin-left: 15px;
  }
  .phone {
    font-size: 28px;
    color: #bcbcbc;
    margin-top: 20px;
    margin-left: 15px;
  }
}
.qrCode {
  margin-top: 30px;
  float: right;
  width: 120px;
  height: 140px;
  background: rgba(249, 249, 249, 1);
  .qrcImg {
    width: 100px;
    height: 100px;
    background: pink;
    margin: 10px;
  }
  span {
    font-size: 12px;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    line-height: 18px;
    text-align: center;
    display: block;
  }
}
.Website {
  font-size: 12px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.3);
  padding-top: 22px;
  text-align: center;
}
</style>
